import { render, staticRenderFns } from "./rentWithdrawal.vue?vue&type=template&id=6bf96866&scoped=true&"
import script from "./rentWithdrawal.vue?vue&type=script&lang=js&"
export * from "./rentWithdrawal.vue?vue&type=script&lang=js&"
import style0 from "./rentWithdrawal.vue?vue&type=style&index=0&id=6bf96866&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf96866",
  null
  
)

export default component.exports